<template>
  <div v-show="!hideButton" @click="openFloatContainer" class="a-vs-b--floating-bubble-wrap"
  :class="{'open': isOpenFloatContainer, 'has_game_switcher': isGameSwitcherVisible}">
    <div class="ticketpanel_handle">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
        </svg>
        <span>{{showFloatText()}}</span>
    </div>
      <div @click="stopPropagation" v-show="isOpenFloatContainer" class="a-vs-b--ticket-container">
        <floating-content
          class="a-vs-ticket-tabs"
          :isBettingEnabled="isBettingEnabled"
          :config="config"
          :amount="amount"
          :numberOfActiveTickets="numberOfActiveTickets"
          :numberOfTickets="numberOfTickets" />
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import { store } from '@/store/store.js'
import EventConstants from '@/constants/Events'
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'

export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    showBettingHistory: {
      type: Boolean
    },
    isBettingEnabled: {
      type: Boolean,
      required: true
    },
    config: {
      type: Object
    },
    amount: {
      type: Number
    }
  },
  data () {
    return {
      totalOdds: 1,
      activeTab: 1,
      isOpenFloatContainer: false,
      numberOfTickets: 0,
      numberOfActiveTickets: 0,
      hideButton: false
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_TOTAL_ODDS, this.updateTotalOdds)
    eventBus.$on(EventConstants.VSOCCER_CHANGE_PICKS_LENGTH, this.updateNumberOfTicket)
    eventBus.$on(EventConstants.VSOCCER_NUMBER_ACTIVE_TICKETS_LENGTH, this.updateActiveTicketLength)
    eventBus.$on(EventConstants.VSOCCER_SHOW_BETTING_HISTORY, this.onEventShowBettingHistory)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_TOTAL_ODDS, this.updateTotalOdds)
    eventBus.$off(EventConstants.VSOCCER_CHANGE_PICKS_LENGTH, this.updateNumberOfTicket)
    eventBus.$off(EventConstants.VSOCCER_NUMBER_ACTIVE_TICKETS_LENGTH, this.updateActiveTicketLength)
    eventBus.$off(EventConstants.VSOCCER_SHOW_BETTING_HISTORY, this.onEventShowBettingHistory)
  },
  computed: {
    isGameSwitcherVisible () {
      return store.isGameSwitcherVisible()
    }
  },
  methods: {
    updateActiveTicketLength (length) {
      this.numberOfActiveTickets = length
    },
    updateNumberOfTicket (length) {
      this.numberOfTickets = length
    },
    stopPropagation () {
      event.stopPropagation()
    },
    onEventShowBettingHistory (isOpen) {
      this.hideButton = isOpen
      if (isOpen) {
        if (this.isOpenFloatContainer) {
          this.isOpenFloatContainer = false
        }
      }
    },
    openFloatContainer: function () {
      this.isOpenFloatContainer = !this.isOpenFloatContainer
      if (this.isOpenFloatContainer) {
        eventBus.onGameScrollLock('true')
      } else {
        if (!this.showBettingHistory) {
          eventBus.onGameScrollUnock('true')
        }
      }
    },
    updateTotalOdds: function (data) {
      this.totalOdds = data
    },
    formatCurrency: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    },
    showFloatText: function () {
      return this.formatCurrency(this.totalOdds === 1 ? '0.00' : this.totalOdds)
    }
  }
}
</script>
